import { DEFAULT_SMOOTHING_ALGORITHM } from '@neptune/shared/smoothing-domain';

// This is typechecked against ChartGlobalConfig next to the
// ChartGlobalConfig definition in order to avoid circular dependency.
export const DEFAULT_CHART_GLOBAL_CONFIG = {
  xAxisMode: undefined,
  xAxisMetric: undefined,
  xAxisScale: undefined,
  xAxisRange: undefined,
  yAxisScale: undefined,
  metricsStepsRange: undefined,
  smoothing: undefined,
  smoothingAlgorithm: DEFAULT_SMOOTHING_ALGORITHM,
  showOriginalLineOnSmoothing: true,
  showCompletion: false,
  outliersDisplayMode: 'none',
  normalizeToFirstValue: undefined,
  showMetricBy: undefined,
} as const;
